import React from 'react';
import type { FC } from 'react';

import styles from './NewsPanel.module.scss';

import type { NewsArticle } from '../../entities/news/model/types';
import { formatNewsDate, toPlainText } from '../../entities/news/lib/format';
import { Loading } from '../ui/Loading/Loading';
import { ChevronRightIcon } from '../../assets/icons/icons';

interface NewsPanelProps {
    news: NewsArticle[];
    isLoading?: boolean;
    onOpenAll: () => void;
    onOpenItem: (item: NewsArticle) => void;
}

export const NewsPanel: FC<NewsPanelProps> = ({ news, isLoading, onOpenAll, onOpenItem }) => (
    <section className={styles.panel}>
        <div className={styles.head}>
            <div>
                <h2>Новости</h2>
                <p>Обновления и важные сообщения сервиса</p>
            </div>

            <button type="button" className={styles.all} onClick={onOpenAll}>
                Все новости →
            </button>
        </div>

        <div className={styles.list}>
            {isLoading && <Loading text="Загружаем новости…" />}

            {!isLoading && news.length === 0 && (
                <p className={styles.hint}>Новостей пока нет.</p>
            )}

            {news.map((item) => (
                <button
                    type="button"
                    className={styles.row}
                    key={item.id}
                    onClick={() => onOpenItem(item)}
                >
                    <time
                        className={styles.date}
                        dateTime={formatNewsDate(item.created_at).split('.').reverse().join('-')}
                    >
                        {formatNewsDate(item.created_at)}
                    </time>
                    <div className={styles.title}>{item.title}</div>
                    <span className={styles.more} aria-hidden="true">
                        <ChevronRightIcon />
                    </span>
                </button>
            ))}
        </div>
    </section>
);
